export default __webpack_public_path__ + "assets/gold-locked-92d96749f97c983d15b21e90f33b1bf8.svg";